/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { Injectable } from '@angular/core';
import { Router, ActivationEnd, Event, ParamMap } from '@angular/router';

import { filter, map } from 'rxjs/operators';

import { RouteUtils } from 'src/app/services/route-utils.service';

@Injectable()
export class LegacyRouting {
	private paramMapSnapshot: ParamMap = {
		keys: [],
		has: () => false,
		get: () => null,
		getAll: () => [],
	};

	private queryMapSnapshot: ParamMap = {
		keys: [],
		has: () => false,
		get: () => null,
		getAll: () => [],
	};

	constructor(private router: Router, private routeUtils: RouteUtils) {
		if (this.router.routerState.snapshot.root.firstChild) {
			this.paramMapSnapshot = this.router.routerState.snapshot.root.firstChild.paramMap;
			this.queryMapSnapshot = this.router.routerState.snapshot.root.firstChild.queryParamMap;
		}
		// Some hacky shit here
		this.router.events
			.pipe(
				filter((evt: Event): evt is ActivationEnd => evt instanceof ActivationEnd),
				map((param: ActivationEnd) => {
					return { paramMap: param.snapshot.paramMap, queryParamMap: param.snapshot.queryParamMap };
				})
			)
			.subscribe((param) => {
				this.paramMapSnapshot = param.paramMap;

				this.queryMapSnapshot = param.queryParamMap;
			});
	}
	public go(basePath: string, ...rest: any[]) {
		const root = '/';
		const commands = [root + basePath, ...rest];

		return this.router.navigate(commands);
	}
	public rawGo(commands: string[]) {
		return this.router.navigate(commands);
	}
	public oldStyleSnapshot() {
		const obj: any = {};

		//do query params first so main ones override
		this.queryMapSnapshot.keys.forEach((key) => {
			obj[key] = this.queryMapSnapshot.get(key);
		});

		this.paramMapSnapshot.keys.forEach((key) => {
			obj[key] = this.paramMapSnapshot.get(key);
		});

		return obj;
	}

	public routeName() {
		return this.routeUtils.routeName();
	}

	public href(path: string[]) {
		const tree = this.router.createUrlTree(path);
		//some hardcoded bs
		const str = '#!' + tree.toString();
		return str;
	}
}
